<template>
    <v-container fluid>
        <slot></slot>
    </v-container>
  </template>
  
  <script>

import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import skutopiaStoreModule from './skutopiaStoreModule'

  export default {
    setup() {

        const SKUTOPIA_APP_STORE_MODULE_NAME = 'app-skutopia'
        // Register module
        if (!store.hasModule(SKUTOPIA_APP_STORE_MODULE_NAME)) store.registerModule(SKUTOPIA_APP_STORE_MODULE_NAME, skutopiaStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
        if (store.hasModule(SKUTOPIA_APP_STORE_MODULE_NAME)) store.unregisterModule(SKUTOPIA_APP_STORE_MODULE_NAME)
        })

    }
  };
  </script>